import script from "./LegalDocumentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocumentLayout.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocumentLayout.vue?vue&type=style&index=0&id=1263199d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1263199d"]])

export default __exports__